import { Link } from 'react-router-dom';



function BreadCumb() {
  return (
    <section className="breadcrumb-area breadcrumb-bg"
      // style={{backgroundImage:'url("img/bg/breadcrumb_bg.jpg")'}}
            style={{ backgroundColor: '#F5CFE8' }} // change color here
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h2 className="title">Liste Chiens</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Acceuil</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Liste Chiens</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
	  
  )
}

export default BreadCumb;
